module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'label')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [(_vm.idioma === 'DE') ? _c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelDe))]) : (_vm.idioma === 'EN') ? _c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelEn))]) : (_vm.idioma === 'ES') ? _c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelEs))]) : _c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [(_vm.exibirGraficoG1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tituloGraficoG1))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.seteDiasGraficoG1
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoG2) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tituloGraficoG2))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.seteDiasGraficoG2
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoG3) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tituloGraficoG3))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.seteDiasGraficoG3
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoG4) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tituloGraficoG4))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.seteDiasGraficoG4
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoG5) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tituloGraficoG5))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.seteDiasGraficoG5
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoG6) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tituloGraficoG6))]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.seteDiasGraficoG6
    }
  })], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d16616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 645
// module chunks = 1